import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from './StyledModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faShieldHalved } from '@fortawesome/free-solid-svg-icons';

import { NotificationManager } from 'react-notifications';

import SwiperCore, { Mousewheel, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'

import { useSelector, useDispatch } from 'react-redux'

import EnterSend from "./EnterSend";

import axios from 'axios';
import { isPinAuthenticated } from '../utils/pinVerification';

SwiperCore.use([Mousewheel, Scrollbar]);

function importAllAvatars(context) {
  return context.keys().sort((firstFile, secondFile) => {
    const firstId = parseInt(firstFile.match(/\d+/), 10);
    const secondId = parseInt(secondFile.match(/\d+/), 10);
    return firstId - secondId;
  }).map((file) => {
    const avatarId = parseInt(file.match(/\d+/)[0], 10);
    const avatarModule = context(file);
    return {
      id: avatarId,
      src: avatarModule.default || avatarModule,
    };
  });
}

const images = importAllAvatars(require.context('../assets/img/avatars', false, /\.(png|jpe?g|svg)$/));

function MyModalComponent(props) {

  function onModalClose(event) {
    props.onCloseModal(event, 1);
  }

  const [pseudo, setPseudo] = React.useState();
  const [idAvatar, setIdAvatar] = React.useState();
  const [pin, setPin] = React.useState(['', '', '', '']);
  const [avatarSliderEdges, setAvatarSliderEdges] = React.useState({ beginning: true, end: false });
  const pinRefs = React.useRef([]);
  const avatarSwiperRef = React.useRef(null);

  const handleSubmit = () => {
    if(props.IsModalOpened === true) {
      saveModif(pseudo, idAvatar, pin.join(''))
    }
  };

  React.useEffect(() => {
    setPseudo(props.user.pseudo)
    setIdAvatar(Number(props.user.id_avatar))
  }, [props.user.pseudo, props.user.id_avatar]);

  React.useEffect(() => {
    if (props.IsModalOpened) {
      setPin(['', '', '', '']);
      window.setTimeout(() => pinRefs.current[0] && pinRefs.current[0].focus(), 100);
    }
  }, [props.IsModalOpened]);

  React.useEffect(() => {
    if (!props.IsModalOpened || !avatarSwiperRef.current) return;
    const avatarIndex = images.findIndex((avatar) => avatar.id === Number(props.user.id_avatar));
    if (avatarIndex >= 0) {
      avatarSwiperRef.current.slideTo(Math.max(avatarIndex - 1, 0), 0);
      setAvatarSliderEdges({
        beginning: avatarSwiperRef.current.isBeginning,
        end: avatarSwiperRef.current.isEnd,
      });
    }
  }, [props.IsModalOpened, props.user.id_avatar]);

  const updateAvatarSliderEdges = (swiper) => {
    setAvatarSliderEdges({ beginning: swiper.isBeginning, end: swiper.isEnd });
  };

  const updatePin = (index, rawValue) => {
    const value = rawValue.replace(/\D/g, '').slice(-1);
    setPin((current) => current.map((digit, digitIndex) => digitIndex === index ? value : digit));
    if (value && index < 3 && pinRefs.current[index + 1]) {
      pinRefs.current[index + 1].focus();
    }
  };

  const handlePinKeyDown = (event, index) => {
    if (event.key === 'Backspace' && !pin[index] && index > 0) {
      pinRefs.current[index - 1].focus();
    }
    if (event.key === 'ArrowLeft' && index > 0) pinRefs.current[index - 1].focus();
    if (event.key === 'ArrowRight' && index < 3) pinRefs.current[index + 1].focus();
  };

  const handlePinPaste = (event) => {
    const digits = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 4).split('');
    if (!digits.length) return;
    event.preventDefault();
    setPin([0, 1, 2, 3].map((index) => digits[index] || ''));
    pinRefs.current[Math.min(digits.length, 4) - 1].focus();
  };

  const user = useSelector(state => state.userGlobal.user)
  const dispatch = useDispatch()

  function saveModif(pseudo, id_avatar, code_pin) {
    if (code_pin.length !== 4) {
      NotificationManager.warning('Saisissez votre code secret à 4 chiffres', '', 3000);
      return;
    }

    const formData = new FormData();
    formData.append('id_compte', user.id_compte)
    formData.append('id_user', props.user.id_user)
    formData.append('pin_code', code_pin)

    axios.post('https://eps.acces-editions.com/api/matchPin', formData)
    .then((res) => {
        if(isPinAuthenticated(res.data, code_pin)) {
              formData.append('id_avatar', id_avatar)
              formData.append('pseudo', pseudo)
              axios.post('https://eps.acces-editions.com/api/updateUserInfo', formData)
              .then(() => {
                axios.get('https://eps.acces-editions.com/api/showUser?id_compte='+user.id_compte)
                .then((res) => {
                    if(res.data.allPseudo[0] !== undefined && res.data.allPseudo[0].pseudo)
                    {
                      NotificationManager.success('Utilisateur mis à jour', '', 3000);
                      dispatch({ type: 'user/userDetail', payload: res.data.allPseudo })
                      onModalClose(false)
                    }
                })
                .catch(() => NotificationManager.error('Impossible de rafraîchir les utilisateurs', '', 3000))
                dispatch({ type: 'user/userConnected', payload: {id_user: props.user.id_user, connected: true, id_avatar: id_avatar, pseudo: pseudo} })
              })
              .catch(() => NotificationManager.error('La modification a échoué. Veuillez réessayer.', '', 3000))
        } else {
          setPin(['', '', '', '']);
          window.setTimeout(() => pinRefs.current[0] && pinRefs.current[0].focus(), 50);
          NotificationManager.error('Code secret invalide', '', 3000);
        }
    })
    .catch(() => NotificationManager.error('La vérification du code a échoué. Veuillez réessayer.', '', 3000))
  }

  return (
    <div>
      <Modal size="sm" active={props.IsModalOpened} toggler={() => {return}}>
        <ModalHeader toggler={() => onModalClose(false)}>
            Modifier les informations
        </ModalHeader>
        <ModalBody>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
              Pseudo
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type='text' defaultValue={pseudo} onChange={(e) => { setPseudo(e.target.value)}} />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
              Avatar
            </label>
            <div className="ae-shared-modal-avatar-picker">
              <button
                type="button"
                className="ae-shared-modal-avatar-navigation"
                onClick={() => avatarSwiperRef.current && avatarSwiperRef.current.slidePrev()}
                disabled={avatarSliderEdges.beginning}
                aria-label="Afficher les avatars précédents"
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <Swiper
                spaceBetween={12}
                slidesPerView={2}
                slidesPerGroup={2}
                slideToClickedSlide={false}
                speed={220}
                mousewheel={{ forceToAxis: false, releaseOnEdges: true, sensitivity: 1.35 }}
                scrollbar={{ draggable: true, hide: false }}
                breakpoints={{
                  480: { slidesPerView: 3, slidesPerGroup: 3 },
                }}
                initialSlide={Math.max(images.findIndex((avatar) => avatar.id === Number(idAvatar)) - 1, 0)}
                onSwiper={(swiper) => {
                  avatarSwiperRef.current = swiper;
                  updateAvatarSliderEdges(swiper);
                }}
                onSlideChange={updateAvatarSliderEdges}
                className="ae-shared-modal-avatar-slider"
              >
                {images.map((avatar) => {
                  const selected = idAvatar === avatar.id;
                  return (
                    <SwiperSlide key={avatar.id}>
                      <button
                        type="button"
                        className={`swiper-no-swiping${selected ? ' is-selected' : ''}`}
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          setIdAvatar(avatar.id);
                        }}
                        aria-label={`Choisir l'avatar ${avatar.id}`}
                        aria-pressed={selected}
                      >
                        <img src={avatar.src} alt={`Avatar ${avatar.id}`} />
                      </button>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              <button
                type="button"
                className="ae-shared-modal-avatar-navigation"
                onClick={() => avatarSwiperRef.current && avatarSwiperRef.current.slideNext()}
                disabled={avatarSliderEdges.end}
                aria-label="Afficher les avatars suivants"
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>
          <div className="mb-6">
            <div className="ae-shared-modal-pin-instruction">
              <FontAwesomeIcon icon={faShieldHalved} />
              <span>Validez les modifications avec votre code secret à 4 chiffres</span>
            </div>
            <div className="ae-shared-modal-pin" onPaste={handlePinPaste}>
              {pin.map((digit, index) => (
                <input
                  key={index}
                  ref={(element) => { pinRefs.current[index] = element; }}
                  type="password"
                  inputMode="numeric"
                  autoComplete={index === 0 ? 'one-time-code' : 'off'}
                  maxLength="1"
                  value={digit}
                  placeholder="•"
                  onChange={(event) => updatePin(index, event.target.value)}
                  onKeyDown={(event) => handlePinKeyDown(event, index)}
                  aria-label={`Chiffre ${index + 1} du code secret`}
                />
              ))}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
            <Button 
                color="red"
                buttonType="link"
                onClick={(e) => onModalClose(false)}
                ripple="dark"
            >
                Fermer
            </Button>

            <Button
                color="green"
                ripple="light"
                onClick={(e) => {saveModif(pseudo, idAvatar, pin.join(''))}}
            >
              <EnterSend handleSubmit={handleSubmit}/>
              Sauvegarder
            </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default MyModalComponent;
